import { Source, Layer } from 'react-map-gl/mapbox';
import type { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl';
import { useGcsStore } from '../../../store/useGcsStore';
import type { ControlZone } from '../../../types/gcs/flightNetwork';

interface GcsControlZoneProps {
  gcsId: string;
}

const controlZoneFillLayer: FillLayerSpecification = {
  id: 'control-zone-fill',
  type: 'fill',
  source: 'control-zone',
  paint: {
    'fill-color': '#ffffff',
    'fill-opacity': 0.3
  }
};

const controlZoneLineLayer: LineLayerSpecification = {
  id: 'control-zone-line',
  type: 'line',
  source: 'control-zone',
  paint: {
    'line-color': '#ffffff',
    'line-width': 2
  }
};

const controlZoneToGeoJSON = (controlZone: ControlZone) => {
  const coordinates = controlZone.points.map((p) => [p.lng, p.lat]);
  // Close the polygon by adding the first point at the end
  if (coordinates.length > 0) {
    coordinates.push(coordinates[0]);
  }
  return {
    type: 'Feature' as const,
    geometry: {
      type: 'Polygon' as const,
      coordinates: [coordinates]
    },
    properties: {}
  };
};

export const GcsControlZone = ({ gcsId }: GcsControlZoneProps) => {
  const controlZone = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    return gcsData?.flightNetwork.data?.centerControlZone;
  });

  if (!controlZone) {
    return null;
  }

  return (
    <Source id={`control-zone-${gcsId}`} type='geojson' data={controlZoneToGeoJSON(controlZone)}>
      <Layer {...controlZoneFillLayer} id={`control-zone-fill-${gcsId}`} source={`control-zone-${gcsId}`} />
      <Layer {...controlZoneLineLayer} id={`control-zone-line-${gcsId}`} source={`control-zone-${gcsId}`} />
    </Source>
  );
};
